import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import { withStyles } from 'material-ui/styles';
import { FusePageSimple } from '@fuse';
import { bindActionCreators } from 'redux';
// import classNames from 'classnames';
// import Products from './components/Products';

import { Button, FormControlLabel, MenuItem, Radio, Typography, Paper } from 'material-ui';
import { TextFieldFormsy, CheckboxFormsy, RadioGroupFormsy, SelectFormsy } from '@fuse';
import TextField from 'material-ui/TextField';
import Formsy from 'formsy-react';
import $ from "jquery";

// import PropTypes from 'prop-types';
import FileUpload from '@material-ui/icons/FileUpload';
import Icon from 'material-ui/Icon';
import IconButton from 'material-ui/IconButton';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import DeleteIcon from '@material-ui/icons/Delete';
import Input, { InputLabel, InputAdornment } from 'material-ui/Input';
import AddIcon from '@material-ui/icons/Add';
import { withAlert } from 'react-alert';
import axios from 'axios';
import 'react-select/dist/react-select.css'

import Dialog, {
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from 'material-ui/Dialog';
import ReactTable from "react-table";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const styles = theme => ({
    layoutRoot: {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot: {
        height: 64
    },
    tabRoot: {
        height: 64
    },
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    container: {
        flexGrow: 1,
        position: 'relative',
        height: 50,
    },
    suggestionsContainerOpen: {
        position: 'absolute',
        zIndex: 1,
        marginTop: theme.spacing.unit,
        left: 0,
        right: 0,
    },
    suggestion: {
        display: 'block',
    },
    suggestionsList: {
        margin: 0,
        padding: 0,
        listStyleType: 'none',
    },
});



// var depertmentName = null;
var previous_employer_name = null;
var id = null;
var nic = null;
var previous_emp_address = null;
var address2 = null;
var state = null;
var city = null;
var zipcode = null;
var countrycode = null;
var email = null;
var telephone = null;
var designation = null;
var from_date = null;
var to_date = null;
var responsibilities = null;
var emp_profile_id = null;
var emp_registry_id = null;
var expected_date;
var suggestions = [];

function renderInput(inputProps) {
    const { classes, ref, ...other } = inputProps;

    return (
        <TextField
            fullWidth
            InputProps={{
                inputRef: ref,
                classes: {
                    input: classes.input,
                },
                ...other,
            }}
        />
    );
}

function renderSuggestions(suggestion, { query, isHighlighted }) {
    const matches = match(suggestion.label, query);
    const parts = parse(suggestion.label, matches);

    return (
        <MenuItem className="popup-value-size" selected={isHighlighted} component="div">
            <div>
                {parts.map((part, index) => {
                    return part.highlight ? (
                        <span key={String(index)} style={{ fontWeight: 300 }}>
                            {part.text}
                        </span>
                    ) : (
                            <strong key={String(index)} style={{ fontWeight: 500 }}>
                                {part.text}
                            </strong>
                        );
                })}
            </div>
        </MenuItem>
    );
}

function renderSuggestionsContainer(options) {
    const { containerProps, children } = options;

    return (
        <Paper {...containerProps} square>
            {children}
        </Paper>
    );
}

function getSuggestions(value) {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    let count = 0;

    return inputLength === 0
        ? []
        : suggestions.filter(suggestion => {
            const keep =
                count < 5 && suggestion.label.toLowerCase().slice(0, inputLength) === inputValue;

            if (keep) {
                count += 1;
            }

            return keep;
        });
}


class Tab3ProfesionalQualification extends Component {

    state = {
        value: 0
    };

    constructor(props) {
        super(props);

        this.state = {
            imageURL: 'assets/images/default-avatar.png',
            data: [],
            inputValue: '',
            selectedItem: [],
            suggestions: [],
            nic: '',
            emp_profile_id: '',
            emp_registry_id: '',
            value: '',
            search_value: '',
            emp: {
                ref_no: '',
                epf_no: '',
                firstName: '',
                middleName: '',
                lastName: '',
            }
        };
        // alert(nic)
        // this.getSuggestions = this.getSuggestions.bind(this);
        this.getSuggestionValue = this.getSuggestionValue.bind(this);
        this.loadData();
        // var end_date = new Date()
        // expected_date = end_date.getMonth() + '/' + end_date.getDate() + '/' + end_date.getFullYear();
        // alert(expected_date)


    }


    handleChange = panel => (event, expanded) => {
        this.setState({
            expanded: expanded ? panel : false,
        });
    };

    handleCloseEdit = () => {
        this.setState({ edit: false });
    };

    handleCloseDelete = () => {
        this.setState({ delete: false });
    };

    onDelete = (model) => {
        this.deleteEmployeeProfesionalQulificationDetail(model);
    };

    onEdit = (model) => {
        this.editEmployeeProfesionalQulificationDetail(model);
    };

    // edit employee profesional qulification details
    editEmployeeProfesionalQulificationDetail(model) {
        // alert(model.id)
        var employeeId = model.id;

        if (null == employeeId || "" == employeeId || undefined == employeeId) {
            // alert("Cannot Delete this Employee");
        } else {

            var editObj = {
                employeeId: model.id,
                nic: model.nic,
                emp_profile_id: model.emp_profile_id,
                emp_registry_id: model.emp_registry_id,
                previous_emp_name: model.previous_employer_name,
                previous_emp_address: model.previous_emp_address,
                address2: model.address2,
                state: model.state,
                city: model.city,
                zipcode: model.zipcode,
                countrycode: model.countrycode,
                email: model.email,
                telephone: model.telephone,
                designation: model.designation,
                fromddate: model.from_date,
                toddate: model.to_date,
                responsibilities: model.responsibilities
            }

            axios.post(window.hrmServer+'/hr/deleteEmpProfesionalQulification', editObj)
                .then(response => {

                    if (response.data.success) {
                        // axios.post('http://localhost:5002/hr/saveEmpProfesionalQulification', editObj)
                        axios.post(window.hrmServer+'/hr/saveEmpProfesionalQulification', editObj)
                            .then(res => {

                                if (res.data.success) {
                                    // alert("Success");
                                    this.props.alert.success("Employee Profesional Qulification Updated Successfully.");
                                    this.handleCloseEdit();
                                    this.loadData();
                                } else {
                                    // alert('Ivalid Credentials');
                                    this.props.alert.error("Error In Employee Profesional Qulification Update.");
                                }
                            })
                    } else {
                        // alert("Delete Faild !");
                    }
                }).catch(function (error) {
                    // alert("Error");
                    console.log("No internet connection or Internal error");
                    // alert("No internet connection or Internal error");
                });

            // axios.post('http://localhost:5002/hr/editEmpProfesionalQulification', editObj)
            //     .then(response => {

            //         if (response.data.success) {
            //             // alert('Success');
            //             this.handleCloseEdit();
            //             this.loadData();
            //         } else {
            //             // alert("Delete Faild !");
            //         }
            //     }).catch(function (error) {
            //         // alert("Error");
            //         console.log("No internet connection or Internal error");
            //         // alert("No internet connection or Internal error");
            //     });
        }
    }

    getSuggestionValue(suggestion) {
        var userProfileObj = {
            nic: suggestion.label
        }
        // alert(config.server.host)
        // axios.post('http://localhost:5002/hr/loadEmpDetailsByNic', userProfileObj)
        axios.post(window.hrmServer+'/hr/loadEmpDetailsByNic', userProfileObj)
            .then(response => {
                if (response.data.success) {
                    // alert('Success'+response.data.result[0].DESIGNATION);
                    var designationObj = response.data.result;
                    // var img = 'http://localhost:3000/' + designationObj[0].PROFILE_IMAGE
                    // var img = 'http://192.169.143.105:3006/' + designationObj[0].PROFILE_IMAGE
                    var img = designationObj[0].PROFILE_IMAGE
                }
                this.setState({
                    imageURL: img,
                    emp: {
                        ref_no: designationObj[0].REF_NO,
                        epf_no: designationObj[0].EPF_CPF,
                        firstName: designationObj[0].FIRST_NAME,
                        middleName: designationObj[0].MIDDLE_NAME,
                        lastName: designationObj[0].LAST_NAME
                    },
                    nic: designationObj[0].NIC,
                    emp_profile_id: designationObj[0].ID_EMPLOYEE_PROFILE,
                    emp_registry_id: designationObj[0].ID_EMPLOYEE_REGISTRY,


                });
                // this.props.nicpasser(designationObj[0].NIC,
                //     designationObj[0].ID_EMPLOYEE_PROFILE,
                //     designationObj[0].ID_EMPLOYEE_REGISTRY);

            }).catch(function (error) {
                console.log("err " + error);
                // alert("No internet connection or Internal error");
            });
        return suggestion.label;
    }

    handleSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            suggestions: getSuggestions(value),
        });
    };

    handleSuggestionsClearRequested = () => {
        this.setState({
            suggestions: [],
        });
    };

    handleChanges = (event, { newValue }) => {
        // alert(newValue)
        this.setState({
            value: newValue,
        });
        this.loadSearchNIC(newValue)
    };

    //nic search
    loadSearchNIC(value) {
        var userProfileObj = {
            searchVal: value
        }
        // axios.post('http://localhost:5002/hr/searchEmployeeByNic', userProfileObj)
        axios.post(window.hrmServer+'/hr/searchEmployeeByNic', userProfileObj)
            .then(response => {
                if (response.data.success) {
                    // alert('Success'+response.data.result[0].DESIGNATION);
                    var designationObj = response.data.result;
                    // console.log("peeen "+employeeObj[31].PROFILE_IMAGE);
                    suggestions = [];
                    for (var i = 0; i < designationObj.length; i++) {

                        suggestions.push({
                            label: designationObj[i].NIC
                        });
                    }
                    this.setState({ suggestions: suggestions });
                }


            }).catch(function (error) {
                console.log("err " + error);
                // alert("No internet connection or Internal error");
            });
    }


    // delete employee profesional qulification details
    deleteEmployeeProfesionalQulificationDetail(model) {
        // alert(model.id)
        var employeeId = model.id;

        if (null == employeeId || "" == employeeId || undefined == employeeId) {
            alert("Cannot Delete this Employee");
        } else {

            var deleteObj = {
                employeeId: employeeId
            }

            axios.post(window.hrmServer+'/hr/deleteEmpProfesionalQulification', deleteObj)
                .then(response => {

                    if (response.data.success) {
                        // alert('Success');
                        this.props.alert.success("Employee Profesional Qulification Deleted Successfully.");
                        this.handleCloseDelete();
                        this.loadData();
                    } else {
                        // alert("Delete Faild !");
                        this.props.alert.error("Error In Employee Profesional Qulification Deleting.");
                    }
                }).catch(function (error) {
                    // alert("Error");
                    console.log("No internet connection or Internal error");
                    // alert("No internet connection or Internal error");
                });
        }
    }


    loadData() {
        var data = [];

        // axios.get('http://localhost:5002/hr/getEmpProfesionalQulification')
        axios.get(window.hrmServer+'/hr/getEmpProfesionalQulification')
            .then(response => {
                if (response.data.success) {
                    // alert('Success');
                    var empProfesionalQualificationObj = response.data.rows;
                    // console.log("peeen "+employeeObj[31].PROFILE_IMAGE);

                    for (var i = 0; i < empProfesionalQualificationObj.length; i++) {

                        data.push({
                            previous_employer_name: empProfesionalQualificationObj[i].PREVIOUS_EMPLOYEE_NAME,
                            previous_emp_address: empProfesionalQualificationObj[i].PREVIOUS_EMPLOYEE_ADDRESS,
                            address2: empProfesionalQualificationObj[i].ADDRESS,
                            nic: empProfesionalQualificationObj[i].NIC,
                            state: empProfesionalQualificationObj[i].STATE,
                            city: empProfesionalQualificationObj[i].CITY,
                            zipcode: empProfesionalQualificationObj[i].ZIPCODE,
                            countrycode: empProfesionalQualificationObj[i].COUNTRY_CODE,
                            email: empProfesionalQualificationObj[i].EMAIL,
                            telephone: empProfesionalQualificationObj[i].TELEPHONE,
                            designation: empProfesionalQualificationObj[i].DESIGNATION,
                            from_date: empProfesionalQualificationObj[i].FROM_DATE,
                            to_date: empProfesionalQualificationObj[i].TO_DATE,
                            id: empProfesionalQualificationObj[i].ID_PROFESIONAL_QULIFICATION,
                            emp_profile_id: empProfesionalQualificationObj[i].ID_EMPLOYEE_PROFILE,
                            responsibilities: empProfesionalQualificationObj[i].DUTIES_AND_RESPONSIBILITIES,
                            emp_registry_id: empProfesionalQualificationObj[i].ID_EMPLOYEE_REGISTRY
                        });
                    }
                }
                this.setState({ data: data });

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });

        this.handleCloseEdit();
    }

    loadSearchData(searchValue) {

        const searchValueObj = {
            searchval: searchValue
        }
        var data = [];

        // axios.post('http://localhost:5002/hr/searchEmpProfesionalQulification', searchValueObj)
        axios.post(window.hrmServer+'/hr/searchEmpProfesionalQulification', searchValueObj)
            .then(response => {
                if (response.data.success) {
                    // alert('Success');
                    var empProfesionalQualificationObj = response.data.resultSearch;
                    // console.log("peeen "+employeeObj[31].PROFILE_IMAGE);

                    for (var i = 0; i < empProfesionalQualificationObj.length; i++) {

                        data.push({
                            previous_employer_name: empProfesionalQualificationObj[i].PREVIOUS_EMPLOYEE_NAME,
                            previous_emp_address: empProfesionalQualificationObj[i].PREVIOUS_EMPLOYEE_ADDRESS,
                            address2: empProfesionalQualificationObj[i].ADDRESS,
                            nic: empProfesionalQualificationObj[i].NIC,
                            state: empProfesionalQualificationObj[i].STATE,
                            city: empProfesionalQualificationObj[i].CITY,
                            zipcode: empProfesionalQualificationObj[i].ZIPCODE,
                            countrycode: empProfesionalQualificationObj[i].COUNTRY_CODE,
                            email: empProfesionalQualificationObj[i].EMAIL,
                            telephone: empProfesionalQualificationObj[i].TELEPHONE,
                            designation: empProfesionalQualificationObj[i].DESIGNATION,
                            from_date: empProfesionalQualificationObj[i].FROM_DATE,
                            to_date: empProfesionalQualificationObj[i].TO_DATE,
                            id: empProfesionalQualificationObj[i].ID_PROFESIONAL_QULIFICATION,
                            responsibilities: empProfesionalQualificationObj[i].DUTIES_AND_RESPONSIBILITIES,
                            emp_profile_id: empProfesionalQualificationObj[i].ID_EMPLOYEE_PROFILE,
                            emp_registry_id: empProfesionalQualificationObj[i].ID_EMPLOYEE_REGISTRY

                        });
                    }
                }
                this.setState({ data: data });

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });

        this.handleCloseEdit();
    }

    onSubmit = (model) => {
        // alert($('#integration-downshift-simple').val())
        if ("" == this.state.emp_profile_id || null == this.state.emp_profile_id || undefined == this.state.emp_profile_id ||
            "" == this.state.emp_registry_id || null == this.state.emp_registry_id || undefined == this.state.emp_registry_id) {
            this.props.alert.error("Unable to Saved Please Check !");
        } else {
            this.saveProfesionalQulifiation(model);
        }

    };

    handleSearchAny = (e) => {
        // alert(e.target.value)
        this.setState({
            search_value: e.target.value
        });
        this.loadSearchData(e.target.value)
    }

    clearValue = () => {
        this.form.reset();
        this.setState({
            value: ''
        });
    }


    saveProfesionalQulifiation(model) {
        const profesionalQulifiationObj = {
            nic: this.state.nic,
            emp_profile_id: this.state.emp_profile_id,
            emp_registry_id: this.state.emp_registry_id,
            previous_emp_name: model.previous_emp_name,
            previous_emp_address: model.previous_emp_address,
            address2: model.address2,
            state: model.state,
            city: model.city,
            zipcode: model.zipcode,
            countrycode: model.countrycode,
            email: model.email,
            telephone: model.telephone,
            designation: model.designation,
            fromddate: model.fromddate,
            toddate: model.toddate,
            responsibilities: model.responsibilities
        }


        var strtDt = new Date(model.fromddate);
        var endDt = new Date(model.toddate);
        var flag = 0; // false



        if (endDt.getTime() <= strtDt.getTime()) {
            this.props.alert.error("to date Can't be less than from date");
        } else {
            // axios.post('http://localhost:5002/hr/saveEmpProfesionalQulification', profesionalQulifiationObj)
            axios.post(window.hrmServer+'/hr/saveEmpProfesionalQulification', profesionalQulifiationObj)
                .then(res => {

                    if (res.data.success) {
                        // alert("Success");
                        this.props.alert.success("Employee Profesional Qulification Added Successfully.");
                        this.form.reset();
                        this.loadData();
                    } else {
                        // alert('Ivalid Credentials');
                        this.props.alert.error("Error In Employee Profesional Qulification Adding.");
                    }
                })
        }

    }

    render() {

        const { classes, setSearchText, searchText } = this.props;
        const { value } = this.state;

        return (
            <div className="{classes.root} mt-16">
                <Formsy
                    onValidSubmit={this.onSubmit}
                    onValid={this.enableButton}
                    onInvalid={this.disableButton}
                    ref={(form) => this.form = form}
                    className="flex flex-col justify-center"
                >

                    <div className="flex flex-wrap p-16 mt-4 pr-24 mb-6 border-solid border-1 rounded border-grey bg-grey-lightest">
                    {/* <Typography className="{classes.heading} flex flex-wrap">Personal Details</Typography> */}
                        <div className="w-full md:w-1/4  pr-24">
                            <div className="MuiAvatar-root-915 w-80 h-80">
                                <img id="profileImg" src={this.state.imageURL} className="w-80 h-80" />
                            </div>
                        </div>

                        <div className="w-full md:w-1/4 mt-16 pr-24">
                            <Autosuggest
                                // className="w-full pt-8"
                                theme={{
                                    container: classes.container,
                                    suggestionsContainerOpen: classes.suggestionsContainerOpen,
                                    suggestionsList: classes.suggestionsList,
                                    suggestion: classes.suggestion,
                                }}
                                renderInputComponent={renderInput}
                                suggestions={this.state.suggestions}
                                onSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
                                onSuggestionsClearRequested={this.handleSuggestionsClearRequested}
                                renderSuggestionsContainer={renderSuggestionsContainer}
                                getSuggestionValue={this.getSuggestionValue}
                                renderSuggestion={renderSuggestions}

                                inputProps={{
                                    classes,
                                    placeholder: 'Search NIC',
                                    value: this.state.value,
                                    onChange: this.handleChanges,
                                    // onSelect:this.selectChange,
                                    // onKeyPress : this.handleChanges,
                                }}

                            />

                        </div>

                        <div className="w-full md:w-1/4 -mt-2 pr-24">


                            {/* <DownshiftMultiple placeholder={{ph:'EPF No', id: 'epfNoSearch'}} /> */}
                            <TextFieldFormsy
                                ref="searchRefNo"
                                className="w-full"
                                type="text"
                                name="searchRefNo"
                                label="Ref.No"
                                disabled={true}
                                validations={{
                                    maxLength: 50
                                }}
                                validationErrors={{

                                    maxLength: 'This is not a valid '
                                }}
                                value={this.state.emp.ref_no}


                            />
                        </div>

                        <div className="w-full md:w-1/4 -mt-2 pr-24">
                            {/* <DownshiftMultiple placeholder={{ph:'EPF No', id: 'epfNoSearch'}} /> */}
                            <TextFieldFormsy
                                id="searchEpfNox    "
                                className="w-full"
                                type="text"
                                name="searchEpfNo"
                                label="EPF No"
                                disabled={true}
                                validations={{
                                    maxLength: 50
                                }}
                                validationErrors={{

                                    maxLength: 'This is not a valid '
                                }}
                                value={this.state.emp.epf_no}
                            // disabled

                            />
                        </div>

                        <TextFieldFormsy
                            className="w-full md:w-1/3 -mt-2 pr-24"
                            type="text"
                            name="lastName"
                            label="Last Name"
                            disabled={true}
                            // validations={{
                            //     required: ""
                            // }}
                            validationErrors={{
                                minLength: 'Min character length is 4'
                            }}
                            validations={{
                                maxLength: 150
                            }}
                            validationErrors={{

                                maxLength: 'This is not a valid r'
                            }}
                            required
                            value={this.state.emp.lastName}
                        />

                        <TextFieldFormsy
                            className="w-full md:w-1/3 -mt-2  pr-24"
                            type="text"
                            name="firstName"
                            label="First Name"
                            disabled={true}
                            // validations={{
                            //     required: ""
                            // }}
                            validations={{
                                maxLength: 150
                            }}
                            validationErrors={{

                                maxLength: 'This is not a valid '
                            }}
                            validationErrors={{
                                minLength: 'Min character length is 4'
                            }}
                            required
                            value={this.state.emp.firstName}
                        />

                        <TextFieldFormsy
                            className="w-full md:w-1/3 -mt-2  pr-24"
                            type="text"
                            name="middleName"
                            label="Middle Name"
                            validations={{
                                maxLength: 150
                            }}
                            disabled={true}
                            validationErrors={{

                                maxLength: 'This is not a valid'
                            }}
                            value={this.state.emp.middleName}
                        />
                    </div>

                    <div className="w-full p-16 mt-4 pr-24 border-solid border-1 rounded border-grey bg-grey-lightest">

                        <TextFieldFormsy
                            className="w-full md:w-1/3 pr-24"
                            type="text"
                            name="previous_emp_name"
                            label="Previous Employer Name"
                            validations={{
                                maxLength: 50
                            }}
                            validationErrors={{

                                maxLength: 'This is not a valid'
                            }}

                        />
                        <TextFieldFormsy
                            className="w-full md:w-1/3 pr-24"
                            type="text"
                            name="previous_emp_address"
                            label="Previous Employer Address"
                            validations={{
                                maxLength: 150
                            }}
                            validationErrors={{

                                maxLength: 'This is not a valid'
                            }}
                        />
                        <TextFieldFormsy
                            className="w-full md:w-1/3 pr-16 pr-24"
                            type="text"
                            name="address2"
                            label="Address 2"
                            validations={{
                                maxLength: 150
                            }}
                            validationErrors={{

                                maxLength: 'This is not a valid'
                            }}

                        />
                        <TextFieldFormsy
                            className="w-full md:w-1/4 pr-16 pr-24"
                            type="text"
                            name="state"
                            label="State"
                            validations={{
                                maxLength: 50
                            }}
                            validationErrors={{

                                maxLength: 'This is not a valid'
                            }}

                        />
                        <TextFieldFormsy
                            className="w-full md:w-1/4 pr-24"
                            type="text"
                            name="city"
                            label="City"
                            validations={{
                                maxLength: 50
                            }}
                            validationErrors={{

                                maxLength: 'This is not a valid'
                            }}

                        />
                        <TextFieldFormsy
                            className="w-full md:w-1/4 pr-24"
                            type="text"
                            name="zipcode"
                            label="Zipcode"
                            validations={{
                                maxLength: 50
                            }}
                            validationErrors={{

                                maxLength: 'This is not a valid'
                            }}

                        />

                        <TextFieldFormsy
                            className="w-full md:w-1/4 pr-24"
                            type="text"
                            name="countrycode"
                            label="Country Code"
                            validations={{
                                maxLength: 50
                            }}
                            validationErrors={{

                                maxLength: 'This is not a valid'
                            }}

                        />

                        <TextFieldFormsy
                            className="w-full md:w-1/3 pr-24"
                            type="email"
                            name="email"
                            label="Email"
                            validations="isEmail"
                            validationError="This is not a valid email"


                        />

                        <TextFieldFormsy
                            className="w-full md:w-1/3 pr-24"
                            type="number"
                            name="telephone"
                            label="Telephone"
                            validations={{
                                maxLength: 20
                            }}
                            validationErrors={{

                                maxLength: 'This is not a valid'
                            }}

                        />

                        <TextFieldFormsy
                            className="w-full md:w-1/3 pr-24"
                            type="text"
                            name="designation"
                            label="Job Title/Designation"
                            validations={{
                                maxLength: 50
                            }}
                            validationErrors={{

                                maxLength: 'This is not a valid'
                            }}

                        />

                        <TextFieldFormsy
                            className="{classes.textField}w-full md:w-1/3 pr-24"
                            id="date"
                            label="From :"
                            name="fromddate"
                            type="date"
                            // value={expected_date}
                            // defaultValue={expected_date}
                            // className=" w-full md:w-1/6 mt-16 pr-24"
                            // required
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />

                        <TextFieldFormsy
                            className="{classes.textField}w-full md:w-1/3 pr-24"
                            id="date"
                            label="To :"
                            name="toddate"
                            type="date"
                            defaultValue="2017-05-24"
                            // className=" w-full md:w-1/6 mt-16 pr-24"
                            // required
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />

                        <TextFieldFormsy
                            className="w-full md:w-1/3 pr-24"
                            type="text"
                            name="responsibilities"
                            label="Duties and Responsibilities"
                            validations={{
                                maxLength: 150
                            }}
                            validationErrors={{

                                maxLength: 'This is not a valid'
                            }}

                        />


                        <div className="w-full md:w-2/3">

                        </div>

                        <div className="w-full md:w-1/3 float-right mb-16">
                            {/* onClick={this.saveEmployee.bind(this)} */}

                            <Button type="submit" variant="raised" size="small" color="secondary" className="{classes.button} w-full md:w-1/3 md:h-24 mt-16 mr-8">
                                Save
                            </Button>

                            <Button type="button" variant="raised" size="small" className="{classes.button} w-full md:w-1/3 md:h-24 mt-16" onClick={this.clearValue}>
                                Clear
                            </Button>
                        </div>
                    </div>
                </Formsy>


                <div className="flex flex-wrap -mx-3 mb-12">
                    <div className="w-full md:w-2/3"></div>
                    <div className="w-full md:w-1/3">
                        {/* <Icon className="-mb-32 -mr-16" color="action">search</Icon> */}
                        <TextField
                            placeholder="Search for anything"
                            className="pl-16"
                            fullWidth
                            value={this.state.search_value}
                            inputProps={{
                                'aria-label': 'Search'
                            }}
                            onChange={this.handleSearchAny}
                        />
                    </div>
                </div>


                <div class="flex h-auto">

                    <div class="w-full bg-white h-auto">
                        <ReactTable
                            getTrProps={(state, rowInfo, column) => {
                                return {
                                    className: "cursor-pointer",
                                    onClick: (e, handleOriginal) => {

                                    }
                                }
                            }}
                            data={this.state.data}
                            columns={[
                                {
                                    Header: "Previous Employer Name",
                                    className: "justify-start",
                                    accessor: "previous_employer_name"

                                },
                                {
                                    Header: "Job Title/Designation",
                                    className: "justify-start",
                                    accessor: "designation"

                                },
                                {
                                    Header: "From Date",
                                    className: "justify-start",
                                    accessor: "from_date"

                                },
                                {
                                    Header: "To date",
                                    className: "justify-start",
                                    accessor: "to_date"

                                },
                                {
                                    Header: "Action",
                                    className: "justify-start",
                                    // accessor: "su",
                                    width: 128,
                                    Cell: row => (
                                        <div className="flex items-center w-8 h-8">
                                            <IconButton

                                                onClick={(e) => {
                                                    if (row) {
                                                        previous_employer_name = row.original.previous_employer_name;
                                                        id = row.original.id;
                                                        nic = row.original.nic;
                                                        previous_emp_address = row.original.previous_emp_address;
                                                        address2 = row.original.address2;
                                                        state = row.original.state;
                                                        city = row.original.city;
                                                        zipcode = row.original.zipcode;
                                                        countrycode = row.original.countrycode;
                                                        email = row.original.email;
                                                        telephone = row.original.telephone;
                                                        designation = row.original.designation;
                                                        from_date = row.original.from_date;
                                                        to_date = row.original.to_date;
                                                        responsibilities = row.original.responsibilities;
                                                        emp_profile_id = row.original.emp_profile_id;
                                                        emp_registry_id = row.original.emp_registry_id;
                                                        this.setState({ edit: true });
                                                    }
                                                }}

                                            >
                                                <Icon className="text-blue">mode_edit</Icon>
                                            </IconButton>

                                            {/* ///// */}
                                            <Dialog

                                                open={this.state.edit}
                                                onClose={this.handleCloseEdit}
                                                aria-labelledby="form-dialog-title"
                                            >
                                                <Formsy
                                                    onValidSubmit={this.onEdit}
                                                    onValid={this.enableButtonEdit}
                                                    onInvalid={this.disableButtonEdit}
                                                    ref={(form) => this.form = form}
                                                    className=""
                                                >
                                                    <DialogTitle id="form-dialog-title">Edit Profesional Qualification Details</DialogTitle>
                                                    <DialogContent className="flex flex-wrap">

                                                        <div className="w-full">

                                                            <TextFieldFormsy
                                                                type="hidden"
                                                                name="id"
                                                                value={id}
                                                            />
                                                            <TextFieldFormsy
                                                                type="hidden"
                                                                name="emp_profile_id"
                                                                value={emp_profile_id}
                                                            />
                                                            <TextFieldFormsy
                                                                type="hidden"
                                                                name="emp_registry_id"
                                                                value={emp_registry_id}
                                                            />

                                                            <TextFieldFormsy
                                                                className="w-1/3 pr-8"
                                                                type="text"
                                                                name="nic"
                                                                label="NIC No"
                                                                value={nic}
                                                                required
                                                                disabled={true}
                                                            />

                                                            <TextFieldFormsy
                                                                className="w-1/3 pr-8"
                                                                type="text"
                                                                name="previous_employer_name"
                                                                label="Previous Employer Name"
                                                                value={previous_employer_name}

                                                            />

                                                            <TextFieldFormsy
                                                                className="w-1/3"
                                                                type="text"
                                                                name="address2"
                                                                label="Address 2"
                                                                value={address2}

                                                            />
                                                        </div>

                                                        <div className="w-full">
                                                            <TextFieldFormsy
                                                                className="w-full mt-16"
                                                                type="text"
                                                                name="previous_emp_address"
                                                                label="Previous Employer Address"
                                                                value={previous_emp_address}
                                                            // required
                                                            // disabled={true}
                                                            />
                                                        </div>
                                                        <div className="w-full">
                                                            <TextFieldFormsy
                                                                className="w-full mt-16"
                                                                type="text"
                                                                name="responsibilities"
                                                                label="Duties and Responsibilities"
                                                                value={responsibilities}
                                                            // required
                                                            // disabled={true}
                                                            />
                                                        </div>

                                                        <div className="w-full">
                                                            <TextFieldFormsy
                                                                className="w-full mt-16"
                                                                type="text"
                                                                name="state"
                                                                label="State"
                                                                value={state}
                                                            // required
                                                            // disabled={true}
                                                            />
                                                        </div>

                                                        <div className="w-full">
                                                            <TextFieldFormsy
                                                                className="w-1/2 pr-8 mt-16"
                                                                type="text"
                                                                name="city"
                                                                label="City"
                                                                value={city}
                                                            // required
                                                            // disabled={true}
                                                            />

                                                            <TextFieldFormsy
                                                                className="w-1/2 mt-16"
                                                                type="text"
                                                                name="email"
                                                                label="Email"
                                                                value={email}
                                                                validations="isEmail"
                                                                validationError="This is not a valid email"
                                                            />
                                                        </div>

                                                        <div className="w-full">
                                                            <TextFieldFormsy
                                                                className="w-1/2 pr-8 mt-16"
                                                                type="text"
                                                                name="telephone"
                                                                label="Telephone"
                                                                value={telephone}
                                                            // disabled={true}
                                                            />

                                                            <TextFieldFormsy
                                                                className="w-1/2 mt-16"
                                                                type="text"
                                                                name="designation"
                                                                label="Designation"
                                                                value={designation}
                                                            // disabled={true}
                                                            />
                                                        </div>

                                                        <div className="w-full">
                                                            <TextFieldFormsy
                                                                className="w-1/4 pr-8 mt-16"
                                                                type="date"
                                                                name="from_date"
                                                                label="From Date"
                                                                value={from_date}
                                                            // disabled={true}
                                                            />

                                                            <TextFieldFormsy
                                                                className="w-1/4 pr-8 mt-16"
                                                                type="date"
                                                                name="to_date"
                                                                label="To Date"
                                                                value={to_date}
                                                            // disabled={true}
                                                            />

                                                            <TextFieldFormsy
                                                                className="w-1/4 pr-8 mt-8"
                                                                type="text"
                                                                name="zipcode"
                                                                label="Zip Code"
                                                                value={zipcode}
                                                            // disabled={true}
                                                            />

                                                            <TextFieldFormsy
                                                                className="w-1/4 pr-8 mt-8"
                                                                type="text"
                                                                name="countrycode"
                                                                label="Country Code"
                                                                value={countrycode}
                                                            // disabled={true}
                                                            />
                                                        </div>
                                                    </DialogContent>
                                                    <DialogActions>
                                                        <Button type="button" onClick={this.handleCloseEdit} variant="raised" size="small" color="primary" className="{classes.button} w-full  md:h-24">
                                                            Close
                                                        </Button>

                                                        <Button type="submit" variant="raised" size="small" color="secondary" className="{classes.button} w-full md:h-24 ">
                                                            Update
                                                        </Button>
                                                    </DialogActions>
                                                </Formsy>
                                            </Dialog>


                                            {/* ///// */}

                                            <IconButton
                                                onClick={(e) => {
                                                    if (row) {

                                                        // updateTradeId = row.original.superTradeId;
                                                        // updateTradeName = row.original.superTradeName;
                                                        // isActive = row.original.isActive;
                                                        this.setState({ delete: true });
                                                        id = row.original.id;
                                                        // alert(id);


                                                    }
                                                }}

                                            >
                                                <Icon className="text-red-light">delete</Icon>
                                            </IconButton>


                                            {/* ///// */}

                                            <Dialog
                                                open={this.state.delete}
                                                onClose={this.handleClose}
                                                aria-labelledby="form-dialog-title"
                                            >
                                                <DialogTitle id="form-dialog-title">Delete Profesional Qualification</DialogTitle>
                                                <DialogContent>

                                                    <div>

                                                        <Formsy
                                                            onValidSubmit={this.onDelete}
                                                            onValid={this.enableButtonDelete}
                                                            onInvalid={this.disableButtonDelete}
                                                            ref={(form) => this.form = form}
                                                            className="flex flex-col justify-center"
                                                        >
                                                            <TextFieldFormsy
                                                                type="hidden"
                                                                name="id"
                                                                value={id}
                                                            />

                                                            <DialogActions>
                                                                <Button onClick={this.handleCloseDelete} color="primary">
                                                                    Cancel
                                                                        </Button>

                                                                <Button
                                                                    type="submit"
                                                                    variant="raised"
                                                                    color="primary"
                                                                    className="mx-auto mt-16 pb-15"
                                                                    aria-label="Edit"
                                                                // disabled={!canEdit}
                                                                >
                                                                    Change
                                                                        </Button>
                                                            </DialogActions>
                                                        </Formsy>
                                                    </div>
                                                </DialogContent>


                                            </Dialog>

                                            {/* ///// */}


                                        </div>
                                    )
                                }

                            ]}
                            defaultPageSize={10}
                            className="-striped -highlight"
                        />
                    </div>
                </div>

            </div>



        )
    }

}


export default withStyles(styles, { withTheme: true })(withAlert(Tab3ProfesionalQualification));


// WEBPACK FOOTER //
// ./src/main/content/hr/createEmployee/components/Tab3ProfesionalQualification.js